var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.01 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.17,200h-2.34c-.34-.14-.67-.34-1.03-.41-26.44-5.31-52.89-10.63-79.34-15.87-1.48-.29-1.89-.88-2.01-2.25-1.4-15.75-2.85-31.49-4.27-47.23-1.75-19.37-3.47-38.75-5.23-58.12C5.01,54.74,3.07,33.36,1.11,11.98.81,8.76.37,5.56,0,2.34V0h200.01c-.79,8.5-1.56,16.73-2.3,24.96-1.49,16.52-2.96,33.05-4.46,49.58-1.63,17.88-3.3,35.77-4.92,53.65-1.62,17.82-3.21,35.64-4.79,53.47-.11,1.2-.46,1.77-1.78,2.03-22.77,4.5-45.52,9.05-68.27,13.63-4.12.83-8.21,1.79-12.31,2.7ZM108.44,33.42v74.92h31.39c0,.6.03.99,0,1.37-.92,10.24-1.83,20.48-2.83,30.71-.05.52-.82,1.28-1.37,1.4-5.08,1.1-10.19,2.09-15.29,3.12-3.99.8-7.98,1.61-11.86,2.4v16.85c.62-.07,1.07-.09,1.51-.17,13.71-2.73,27.41-5.48,41.12-8.18,1.06-.21,1.34-.76,1.42-1.71.3-3.63.66-7.26.99-10.89,1.12-12.31,2.25-24.62,3.36-36.93.43-4.78.85-9.56,1.3-14.6h-33.06v-41.73h36.87c.5-5.58.98-10.99,1.48-16.54h-55.02ZM91.51,164.27V33.42h-16.5v110.55c-3.38-.65-6.55-1.37-9.74-1.83-1.86-.27-2.49-1.08-2.44-2.91.05-1.61-.23-3.24-.39-4.86-.29-3.09-.6-6.17-.9-9.26h-16.52c-.05.29-.11.48-.1.66.86,9.52,1.75,19.05,2.57,28.57.11,1.28.89,1.35,1.82,1.53,9.56,1.9,19.12,3.83,28.68,5.74,4.45.89,8.9,1.75,13.52,2.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.3899dbc04a26bb6ade54a886c02ba7c3.svg";
export { ForwardRef as ReactComponent };